const CARDS = [
  {
    icon: "/homepage/move1.svg",
    title: "Daily AI Updates",
    description: "What actually shipped in AI today. In your WhatsApp. Before your first meeting.",
  },
  {
    icon: "/homepage/move2.svg",
    title: "Resources we've actually used",
    description: "Prompts, agents, and workflows. Used in our own work first. You only see what survived.",
  },
  {
    icon: "/homepage/move3.svg",
    title: "Live sessions every week ",
    description: "We get on Zoom and build real workflows for real problems. No slides. No lectures.",
  },
  {
    icon: "/homepage/move4.svg",
    title: "What the community is shipping",
    description: "GPTs, agents, templates, workflows. Members ship every week. You see the best ones.",
  },
] as const;

export default function WhyCommunity() {
  return (
    <section className="w-full bg-black py-16 sm:py-20 font-fira">
      <div className="w-[90%] md:w-[80%] mx-auto">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:gap-10">
          <header className="text-left md:w-[34%] md:shrink-0">
 <p className="mb-4 text-sm font-normal text-white uppercase tracking-[1.75px]">
              What&apos;s inside
            </p>
            <h2 className="mb-4 font-fira-condensed text-[30px] w-full md:w-[70%] font-medium leading-tight tracking-tight text-white md:text-[42px]">
              Keeping up with AI is a system. Here's ours.
            </h2>
            <p className="text-[14px] font-normal leading-relaxed text-[#FFFFFF85] md:text-[16px]">
              Daily updates. Built with depth.
            </p>
          </header>

          <ul
            className="flex flex-1 flex-col gap-6 md:flex-row md:gap-8 lg:gap-10"
            role="list"
          >
            {CARDS.map(({ icon, title, description }) => (
              <li
                key={title}
                className="flex flex-row gap-4 text-left md:flex-1 md:flex-col md:gap-4"
              >
                <img
                  src={icon}
                  alt=""
                  width={32}
                  height={32}
                  className="h-7 w-7 shrink-0 object-contain md:h-8 md:w-8"
                />
                <div className="flex flex-col gap-2">
                  <h3 className="text-base font-semibold leading-snug text-white sm:text-lg">
                    {title}
                  </h3>
                  <p className="text-sm font-normal leading-relaxed text-white/60">
                    {description}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
